import { decode } from "base-64";

function decodeToken(accessToken: string) {
  const payload = accessToken.substring(
    accessToken.indexOf(".") + 1,
    accessToken.lastIndexOf(".")
  );

  const decodingInfo = decode(payload);

  const utf8Decoder = new TextDecoder("utf-8");
  const decodedArray = Uint8Array.from(decodingInfo, (char) =>
    char.charCodeAt(0)
  );
  const utf8Decoded = utf8Decoder.decode(decodedArray);

  return JSON.parse(utf8Decoded);
}

export default decodeToken;
